export enum BroadCastType {
    TabInteraction = "tab_interaction",
    Paynimo = "paynimo"
}